module.exports = __webpack_public_path__ + "img/profile--active.73d54010.svg";